import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import GlobalStyles from "@mui/material/GlobalStyles";
import { MsalProvider } from "@azure/msal-react";
import { Configuration, PublicClientApplication } from "@azure/msal-browser";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";
import { useAppDispatch } from "../redux/store/hooks/use-app.dispatch";
import { fetchTenantInformation } from "../redux/store/slices/tenant/tenant-slice";
import { AppTheme } from "../theme";
import { routes } from "../routes";
import { PageLayout } from "../components";
import { ProtectedRoute } from "../components/ProtectedRoute";

export const App = () => {
  const dispatch = useAppDispatch();
  const { tenantName, webAppId, status } = useSelector(
    (state: RootState) => state.tenantInformation,
  );

  useEffect(() => {
    if (status === "idle") {
      dispatch(fetchTenantInformation());
    }
  }, [status, dispatch]);

  const msalInstance = React.useMemo(() => {
    if (!tenantName || !webAppId) return null;

    const msalConfig: Configuration = {
      auth: {
        clientId: webAppId,
        authority: `https://${tenantName}.b2clogin.com/${tenantName}.onmicrosoft.com/B2C_1_LPLSignIn`,
        knownAuthorities: [`${tenantName}.b2clogin.com`],
        postLogoutRedirectUri: "/",
      },
      cache: {
        cacheLocation: "localStorage",
        storeAuthStateInCookie: true,
      },
    };

    return new PublicClientApplication(msalConfig);
  }, [tenantName, webAppId]);

  // Only render MsalProvider if msalInstance exists
  if (!msalInstance) {
    return null; // nothing rendered until tenant info is ready
  }

  return (
    <MsalProvider instance={msalInstance}>
      <ThemeProvider theme={AppTheme}>
        <GlobalStyles styles={{ body: { backgroundColor: "#F9FCFE" } }} />
        <BrowserRouter>
          <Routes>
            {routes.map((route, index) => (
              <Route
                key={index}
                index={route.index}
                path={route.path!}
                element={
                  route.renderWithLayout ? (
                    <ProtectedRoute>
                      <PageLayout>{route.element}</PageLayout>
                    </ProtectedRoute>
                  ) : (
                    route.element
                  )
                }
              />
            ))}
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </MsalProvider>
  );
};

/*
          <AlertDialog
            type="error"
            title="Access Denied"
            description="You do not have permission to perform this action"
            open={state}
            onCancel={SwitchAlertOff}
            onContinue={SwitchAlertOff}
          />

                <MsalProvider instance={clientApplication}>
                    <ThemeProvider theme={AppTheme} >
                        <GlobalStyles styles={{
                            body: { backgroundColor: "#F9FCFE" }
                        }}
                        />
                        <BrowserRouter>
                            <Routes>
                                {
                                    routes.map((route, index): JSX.Element => {
                                        return (
                                            <Route
                                                key={index}
                                                index={route.index}
                                                path={route.path!}
                                                element={
                                                    route.renderWithLayout ? (
                                                        <ProtectedRoute>
                                                            <PageLayout>{route.element}</PageLayout>
                                                        </ProtectedRoute>
                                                    ) : route.element
                                                }
                                            />
                                        )
                                    })
                                }
                            </Routes>
                        </BrowserRouter>
                        <AlertDialog
                            type="error"
                            title="Access Denied"
                            description="You do not have permission to perform this action"
                            open={false}
                            onCancel={() => { }}
                            onContinue={() => { }}
                        />
                    </ThemeProvider>
                </MsalProvider>*/
